/**
 * Personuppgiftsbilaga till hyresavtal — the bilaga variant.
 *
 * Never a contract of its own: it hangs under a bostads-, student- or
 * lokalhyresavtal and rides that lease's signing, so it declares no party
 * slots and no signing block. The landlord identity is overlaid from the
 * parent lease (see the `derivedFromParent` slots).
 */
import { COMPOSITION_SCHEMA, COMPOSITION_VERSION } from '@hyranai/regta-document-ir';
const TITLE = 'Personuppgiftsbilaga till hyresavtal · Version 2026';
const FORM_NUMBER = 'Formulär R-16';
export const PERSONUPPGIFT_PREAMBLE = 'Information om hyresvärdens behandling av hyresgästens personuppgifter.';
/** Sections 1–9, shared verbatim with the standalone personuppgiftsavtal. */
export function personuppgiftSharedBody(personuppgiftsansvarigRef) {
    return [
        { instanceId: 'preamble', blockRef: 'common.preamble@v1', input: { text: PERSONUPPGIFT_PREAMBLE } },
        { instanceId: 'intro', blockRef: 'personuppgiftsbilaga.intro@v1', input: {} },
        { instanceId: 'personuppgiftsansvarig', blockRef: personuppgiftsansvarigRef, input: {} },
        { instanceId: 'andamal', blockRef: 'personuppgiftsbilaga.andamal@v1', input: {} },
        { instanceId: 'kategorier', blockRef: 'personuppgiftsbilaga.kategorier@v1', input: {} },
        { instanceId: 'rattslig-grund', blockRef: 'personuppgiftsbilaga.rattslig-grund@v1', input: {} },
        { instanceId: 'mottagare', blockRef: 'personuppgiftsbilaga.mottagare@v1', input: {} },
        { instanceId: 'lagringstid', blockRef: 'personuppgiftsbilaga.lagringstid@v1', input: {} },
        { instanceId: 'rattigheter', blockRef: 'personuppgiftsbilaga.rattigheter@v1', input: {} },
        { instanceId: 'klagomal', blockRef: 'personuppgiftsbilaga.klagomal@v1', input: {} },
        { instanceId: 'kontakt', blockRef: 'personuppgiftsbilaga.kontakt@v1', input: {} },
    ];
}
export const letterheadAndFooter = (title, formNumber) => [
    { instanceId: 'letterhead', blockRef: 'common.letterhead@v1', slot: 'letterhead', input: { title, form_number: formNumber } },
    { instanceId: 'footer', blockRef: 'common.page-footer@v1', slot: 'footer', input: { form_number: formNumber } },
];
const META = {
    category: 'Övriga avtal',
    shortTitle: 'Personuppgiftsbilaga',
    formNumber: FORM_NUMBER,
    preamble: PERSONUPPGIFT_PREAMBLE,
    description: 'GDPR-information (artikel 13) om hur hyresvärden behandlar hyresgästens ' +
        'personuppgifter. Rekommenderad bilaga till bostads-, student- och ' +
        'lokalhyresavtal.\n\n' +
        'Skapas som bilaga under ett hyresavtal — visas inte i avtalslistan, har ' +
        'ingen egen signering. Hyresvärdens uppgifter hämtas från avtalet. ' +
        'Bifogas det signerade avtalet automatiskt vid utskick via Scrive.\n\n' +
        'Behöver dokumentet signeras separat (utan ett kopplat hyresavtal) — ' +
        'använd den fristående mallen "Personuppgiftsavtal" under Övriga avtal.',
    statute: 'Europaparlamentets och rådets förordning (EU) 2016/679 (GDPR), artikel 13',
    signingMode: 'parent',
    numberStyle: 'paragraph',
    partySlots: [],
    attachableTo: ['bostadshyra', 'studentbostad', 'lokalhyra'],
    singletonPerParent: true,
};
export const personuppgiftsbilagaV1 = (values = {}) => ({
    schema: COMPOSITION_SCHEMA,
    version: COMPOSITION_VERSION,
    documentKey: 'personuppgiftsbilaga',
    documentVersion: 'v1',
    title: TITLE,
    locale: 'sv-SE',
    meta: META,
    values,
    blocks: [
        ...letterheadAndFooter(TITLE, FORM_NUMBER),
        ...personuppgiftSharedBody('personuppgiftsbilaga.personuppgiftsansvarig@v1'),
        { instanceId: 'bekraftelse', blockRef: 'personuppgiftsbilaga.bekraftelse@v1', input: {} },
    ],
});
//# sourceMappingURL=personuppgiftsbilaga.js.map